import * as React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useTokens } from "./theme";

// Shared shell for the pre-auth pages (login, registration, email
// verification, password reset): a calm static canvas, the product name as
// the page's single <h1>, and one bordered card holding the form.
export default function Panel({ children, maxWidth = 440 }) {
  const tokens = useTokens();

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        padding: "32px 16px",
        boxSizing: "border-box",
        bgcolor: tokens.appBg,
        // Light brand-blue wash, a softened take on the original
        // #02a7db -> white gradient. Kept static (the original animated
        // endlessly) so it respects reduced-motion preferences. The heading
        // stays well above 4.5:1 against even the bluest corner.
        backgroundImage:
          "linear-gradient(135deg, #8fdcf3 0%, #c8eefa 45%, #eef9fd 75%, #ffffff 100%)",
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontSize: { xs: "1.5rem", sm: "1.875rem" },
          fontWeight: 700,
          letterSpacing: "-0.025em",
          color: tokens.foreground,
          textAlign: "center",
        }}
      >
        Sunsure Advance Insights
      </Typography>
      <Card
        sx={{
          width: "100%",
          maxWidth,
          padding: { xs: "24px", sm: "32px" },
          boxSizing: "border-box",
          bgcolor: tokens.card,
        }}
      >
        {children}
      </Card>
    </Box>
  );
}
